<!--<div style="margin-top: 20px"  *ngFor="let htmlData of data">-->
<!--    <div *ngIf="data"  [innerHTML]="htmlData.content" ></div>-->
<!--</div>-->

<div *ngIf="data && data.id">
  <div class="tarif-container" routerLink="/login">
    <div [innerHTML]="sanitizer.bypassSecurityTrustHtml(data.content)"></div>
  </div>
</div>
